import { isEmpty, lowerCase } from "lodash";
import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import secureLocalStorage from "react-secure-storage";
import { useContextSelector } from "use-context-selector";
import BetSlipContext from "../../context/BetSlipContext";
const ListParlay = ({ odds, object, handleScore, showScore }) => {
  function isDateToday(date) {
    return moment(date).isSame(moment(), "day");
  }
  const setParlyBet = useContextSelector(AuthContext, (ctx) => {
    return ctx.setParlyBet;
  });
  const setToastObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setToastObject;
  });
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const parlyBet = useContextSelector(AuthContext, (ctx) => {
    return ctx.parlyBet;
  });
  const navigate = useNavigate();
  const [premiumDetail, setPremiumDetail] = useState([]);
  const [premiumDetail2, setPremiumDetail2] = useState({});
  useEffect(() => {
    const findMarket = (condition) => {
      return (
        odds?.find(
          (res) =>
            Number(res?.betfairEventId) == Number(object?.eventId) &&
            condition(res),
        ) || {}
      );
    };

    const gameTypeConfig = {
      soccer: {
        obj1: (res) => /1x2/i.test(res?.marketName),
        obj2: (res) => res?.marketName?.includes("Total"),
      },
      tennis: {
        obj1: (res) => res?.marketName?.includes("Winner"),
        obj2: (res) =>
          /1x2/i.test(res?.marketName) || res?.marketName === "Total games",
      },
      default: {
        obj1: (res) => res?.marketName?.includes("Winner"),
        obj2: (res) => res?.marketName === "Total",
      },
    };

    const { obj1: cond1, obj2: cond2 } =
      gameTypeConfig[object?.gameType] || gameTypeConfig.default;

    const obj1 = findMarket(cond1);
    if (!isEmpty(obj1)) setPremiumDetail(obj1);

    let obj2 = findMarket(cond2);
    if (!isEmpty(obj2)) {
      setPremiumDetail2(obj2);
    } else if (object?.gameType !== "soccer" && object?.gameType !== "tennis") {
      const fallback = odds?.filter(
        (res) =>
          res?.betfairEventId === object?.eventId &&
          !res?.marketName?.includes("Winner"),
      );
      if (fallback?.length > 0) setPremiumDetail2(fallback[0]);
    }
  }, [object, odds]);

  const handelPaly = (item, res) => {
    if (isEmpty(user)) {
      setToastObject({
        type: "warning",
        title: "Warning",
        message: "Please login to place your bet!",
        status: true,
      });
    } else {
      if (res?.odds >= 1.7) {
        setParlyBet((current) => {
          const newObj = {
            ...item,
            sportsBookSelectionObject: res,
            selectObj: res?.id,
            newEventId: object?.eventId,
            eventName: object?.eventName,
            marketId: object?.marketId,
          };

          // Remove any existing bets for the same eventId
          const updatedList = current.filter(
            (bet) => bet?.newEventId !== object?.eventId,
          );

          // Always add the new bet
          const finalList = [...updatedList, newObj];
          // Save in secureLocalStorage
          secureLocalStorage.setItem("parlyBet", finalList);

          return finalList;
        });
      } else {
        setToastObject({
          type: "warning",
          title: "Warning",
          message: "Odds must be greater than 1.7",
          status: true,
        });
      }
    }
  };
  const BettingSwiper = () => {
    const slides = [{ ...premiumDetail }, { ...premiumDetail2 }, {}, {}];
    return (
      <div className="s-relative">
        <Swiper
          slidesPerView="auto"
          spaceBetween={1}
          pagination={{ clickable: true }}
          modules={[Pagination]}
          className="swiper"
        >
          {slides?.map((slide, index) => {
            const isSuspended =
              slide?.apiSiteStatus === "SUSPENDED" ||
              Number(slide?.marketStatus) !== 1;

            return (
              <SwiperSlide
                key={index}
                className="swiper-slide slide"
                style={{ width: "80.5px" }}
              >
                {isEmpty(slide?.marketName) ? (
                  <div className="s-w-24 s-flex s-text-11px s-text-global-font-default-light dark:s-text-global-font-default-dark s-text-center s-whitespace-nowrap">
                    <div
                      style={{ opacity: "0" }}
                      className="s-min-w-min s-w-full s-flex s-justify-center s-line-clamp-1 s-mx-px s-text-event-th-option s-font-bold s-text-14px s-leading-140"
                    >
                      empty
                    </div>
                  </div>
                ) : (
                  <div className="s-w-24 s-flex s-text-11px s-text-global-font-default-light dark:s-text-global-font-default-dark s-text-center s-whitespace-nowrap">
                    <div className="s-min-w-min s-w-full s-flex s-justify-center s-line-clamp-1 s-mx-px s-text-event-th-option s-font-bold s-text-14px s-leading-140">
                      {lowerCase(slide?.marketName)?.split(" ")?.includes("x")
                        ? "1x2"
                        : lowerCase(slide?.marketName)
                              ?.split(" ")
                              ?.includes("winner")
                          ? "Winner"
                          : slide?.marketName}
                    </div>
                  </div>
                )}
                <div className="s-relative s-flex s-mt-4px s-ml-px">
                  {isSuspended && (
                    <div className="s-z-10 s-absolute -s-mx-px s-left-0 s-top-0 s-flex s-justify-center s-items-center s-w-full s-h-full s-bg-black-600 dark:s-bg-black-900 s-opacity-80 s-text-15px s-text-white s-rounded-3px" />
                  )}

                  <div className="s-w-full s-flex s-flex-col s-space-y-px s-pr-px">
                    {slide?.sportsBookSelection?.length > 0 ? (
                      slide?.sportsBookSelection.slice(0, 2)?.map((res) => {
                        let obj =
                          parlyBet?.length > 0
                            ? parlyBet?.find((item) => {
                                return (
                                  item?.marketName == slide?.marketName &&
                                  item?.sportsBookSelectionObject?.odds ==
                                    res?.odds
                                );
                              })
                            : {};
                        return (
                          <div
                            onClick={() => handelPaly(slide, res)}
                            className="s-h-59px"
                          >
                            <div
                              style={
                                !isEmpty(obj)
                                  ? {
                                      border: "2px solid #878e92",
                                      // background: "#f2f2f2",
                                    }
                                  : {}
                              }
                              className={`s-h-full s-overflow-hidden s-rounded-3px  ${
                                slide.disabled
                                  ? "s-bg-black-300 s-opacity-40"
                                  : "s-bg-parlay-betInfo-light dark:s-bg-parlay-betInfo-dark"
                              }`}
                            >
                              {!slide.disabled && (
                                <div
                                  className={`s-relative s-h-full s-text-center s-flex s-justify-center s-items-center s-flex-col s-overflow-hidden dark:s-text-global-font-default-dark ${
                                    !isEmpty(obj)
                                      ? "s-border s-rounded s-border-white dark:s-border-black-600 s-text-global-font-default-light  "
                                      : ""
                                  }`}
                                  // s-animate-spark-back
                                >
                                  <span className="s-line-clamp-2 s-w-11/12 s-mx-1 s-text-center s-text-11px s-leading-tight dark:s-text-parlay-bet-text">
                                    {res.selectionName}
                                  </span>
                                  <span className="dark:s-text-parlay-bet-text s-text-17px s-font-bold s-px-1 s-mt-px">
                                    {res.odds}
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <>
                        {" "}
                        <div className="s-h-59px">
                          <div className="s-h-full s-bg-black-300 dark:s-bg-black-700 s-rounded s-opacity-75"></div>
                        </div>
                        <div className="s-h-59px">
                          <div className="s-h-full s-bg-black-300 dark:s-bg-black-700 s-rounded s-opacity-75"></div>
                        </div>{" "}
                      </>
                    )}
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    );
  };
  return (
    <div data-v-72620aba className="s-overflow-hidden s-relative">
      <div data-v-72620aba className>
        <div data-v-72620aba>
          <div data-v-72620aba className="s-flex s-w-full">
            <div
              data-v-72620aba
              className="s-rounded-b-5px s-shadow-2sm s-flex s-flex-col s-w-full s-bg-white dark:s-bg-main-block-dark"
            >
              <div
                data-v-72620aba
                className="s-relative s-z-10 s-h-24px s-flex s-justify-end s-items-center s-bg-primary"
              >
                <div
                  data-v-72620aba
                  className="s-absolute s-w-1px s-h-1/2 s-bg-event-th-option s-right-48 s-mr-3px"
                />
              </div>
              <div
                data-v-72620aba
                className="s-flex s-m-4px s-bg-black-100 dark:s-bg-main-block-dark s-rounded-b-3px"
              >
                <div
                  data-v-72620aba
                  className="s-w-full s-h-full s-flex s-flex-col s-justify-between s-px-2 s-pt-10px s-pb-14px s-text-global-font-default-light dark:s-text-global-font-default-dark"
                >
                  <div
                    onClick={() => {
                      navigate(
                        `/match-detail/${object?.eventId}/${object?.marketId}/multi`,
                      );
                    }}
                    data-v-72620aba
                    className="s-space-y-2 s-text-17px s-font-bold"
                  >
                    <div data-v-72620aba>
                      <span
                        data-v-72620aba
                        className="s-break-words s-leading-tight"
                      >
                        {object?.eventName}
                      </span>
                    </div>
                  </div>
                  <div
                    data-v-72620aba
                    className="s-flex s-justify-between s-items-center"
                  >
                    <div
                      data-v-72620aba
                      className="s-flex s-gap-2px s-justify-start s-items-center"
                    >
                      {/**/}
                      {object?.status == "in_play" ? (
                        <div
                          data-v-88ac4f64
                          className="s-overflow-hidden s-flex s-flex-col s-rounded-3px"
                        >
                          <div className="s-px-3px s-leading-14px s-flex s-items-center s-justify-center s-bg-inPlay-light dark:s-bg-inPlay-dark s-text-black s-flex-1">
                            <span className="s-text-12px s-leading-120 s-text-center">
                              In-play
                            </span>
                          </div>
                        </div>
                      ) : (
                        <div
                          data-v-88ac4f64
                          className="s-overflow-hidden s-flex s-flex-col s-rounded-3px"
                        >
                          <div className="s-time-block s-flex s-items-center s-justify-center s-flex-1 s-bg-today-light dark:s-bg-today-dark">
                            <span className="s-text-12px s-leading-120 s-text-black s-text-center s-whitespace-nowrap s-px-3px s-py-0">
                              {isDateToday(object?.eventDateTime)
                                ? "Today"
                                : moment(object?.eventDateTime).format("DD/MM")}
                            </span>
                            <span className="s-text-12px s-leading-120 s-text-black s-text-center s-pr-3px">
                              {moment(object?.eventDateTime).format("HH:MM")}
                            </span>
                          </div>
                        </div>
                      )}
                      {/**/}
                    </div>
                    {!isEmpty(object?.scoreId) && (
                      <i
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleScore(object?.scoreId);
                        }}
                        data-v-72620aba
                        className={`s-ml-10px s-text-16px ${
                          showScore?.includes(object?.scoreId)
                            ? "s-icon-h2h-solid"
                            : "s-icon-h2h"
                        }`}
                      />
                    )}
                  </div>
                </div>
                <div
                  data-v-72620aba
                  className="s-relative s-parlay-content -s-mt-24px"
                >
                  <div className="s-relative s-h-full">
                    <div className="s-flex s-h-full s-overflow-hidden">
                      <div className="s-shrink-0 s-w-48">
                        <BettingSwiper />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/**/}
        </div>
      </div>
    </div>
  );
};

export default ListParlay;
